export default "__VITE_ASSET__3e638971__"